import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';

export default function instructorBreadcrumb<T extends RouteComponentProps>(WrappedComponent: React.ComponentType<T>, options = {}) {

    type State = {
        Name: string;
    }

    type Props = RouteComponentProps<{ instructorId: string }>;

    return class extends React.Component<Props, State> {

        constructor(props: Props) {
            super(props);

            this.state = {
                Name: ''
            }

            this.fetchInstructorName = this.fetchInstructorName.bind(this);
        }

        componentDidMount() {
            this.fetchInstructorName(parseInt(this.props.match.params.instructorId));
        }

        componentWillReceiveProps(nextProps: Props) {
            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                this.fetchInstructorName(parseInt(nextProps.match.params.instructorId));
            }
        }

        render() {
            return <React.Fragment>
                <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                            <Link to='/instructors'>Instructors</Link>
                    </li>
                        <li className="breadcrumb-item active" aria-current="page">{this.state.Name}</li>
                </ol>
                </nav>
                <WrappedComponent {...(this.props as T)} />
            </React.Fragment>
            ;
        }

        private fetchInstructorName(instructorId: number) {
            if (instructorId == 0) {
                this.setState({ Name: "New " })
            } else {
                fetchApi(`/api/Breadcrumb/Instructor/${instructorId}`)
                    .then((Name) => this.setState({ Name }))
            }
        };
    };
}
